<script lang="ts">
  import { onMount } from "svelte";
  import { api, type AlertItem } from "../lib/api";

  let { onback, onhome }: { onback?: () => void; onhome?: () => void } = $props();

  let items = $state<AlertItem[]>([]);
  let total = $state(0);
  let loading = $state(true);
  let error = $state<string | null>(null);

  function priceFmt(rub: number): string {
    if (rub >= 1_000_000) return `${(rub / 1_000_000).toFixed(1).replace(/\.0$/, "")}М ₽`;
    if (rub >= 1000) return `${Math.floor(rub / 1000)}к ₽`;
    return `${rub} ₽`;
  }
  function ageText(d: number): string {
    if (d <= 0) return "сегодня";
    if (d === 1) return "1 день";
    if (d < 5) return `${d} дня`;
    return `${d} дней`;
  }

  onMount(async () => {
    try {
      const r = await api.alertsAll();
      items = r.items;
      total = r.total;
    } catch (e) {
      error = e instanceof Error ? e.message : "ошибка";
    } finally {
      loading = false;
    }
  });
</script>

<div class="screen">
  <header class="hdr">
    <button class="back" onclick={() => onback?.()} aria-label="Назад">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
    </button>
    <div class="title">Алерты · {total}</div>
    <button class="home" onclick={() => onhome?.()} aria-label="Главная">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
      </svg>
    </button>
  </header>

  {#if loading}
    <div class="loading">Загружаю…</div>
  {:else if error}
    <div class="error-box">{error}</div>
  {:else if items.length === 0}
    <div class="empty">Алертов нет</div>
  {:else}
    <section class="alerts">
      {#each items as a}
        <a class="alert {a.tone}" href={`?deal=${a.lead_amo_id}`}>
          <div class="top">
            <div class="deal-name">{a.deal_name}{#if a.vip}<span class="vip-mark">VIP</span>{/if}</div>
            <div class="deal-price">{priceFmt(a.price_rub)}</div>
          </div>
          <div class="meta">
            {a.manager_name} <span class="sep"></span>
            {a.stage_name} <span class="sep"></span>
            {ageText(a.age_days)}
          </div>
          <div class="reason">{a.reason}</div>
        </a>
      {/each}
    </section>
  {/if}
</div>

<style>
  .screen { padding-bottom: 80px; }
  .hdr {
    padding: calc(12px + var(--safe-top, 0px)) 16px 12px;
    display: flex; align-items: center; gap: 8px;
    border-bottom: 1px solid var(--border);
  }
  .back, .home {
    width: 36px; height: 36px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    color: var(--text-mute);
  }
  .back:active, .home:active { background: var(--bg-elev); }
  .back svg, .home svg { width: 20px; height: 20px; }
  .title {
    font-family: 'Manrope', sans-serif;
    font-size: 16px; font-weight: 700;
    flex: 1; text-align: center;
  }
  .loading, .error-box, .empty { padding: 40px 16px; text-align: center; color: var(--text-mute); font-size: 13px; }
  .error-box { color: var(--danger); }

  .alerts { padding: 12px 16px; display: flex; flex-direction: column; gap: 8px; }
  .alert {
    display: block;
    background: var(--bg-elev);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px 14px;
    color: var(--text);
    text-decoration: none;
    box-shadow: var(--shadow-sm);
    position: relative;
    overflow: hidden;
    transition: transform 80ms ease;
  }
  .alert:active { transform: scale(0.985); }
  .alert::before {
    content: ''; position: absolute;
    left: 0; top: 0; bottom: 0; width: 3px;
    background: var(--danger);
  }
  .alert.warn::before { background: var(--warning); }
  .alert.vip::before { background: var(--vip); }

  .top {
    display: flex; justify-content: space-between; align-items: center;
    margin-bottom: 4px;
  }
  .deal-name {
    font-family: 'Manrope', sans-serif;
    font-weight: 600; font-size: 14px;
  }
  .vip-mark { color: var(--vip); font-size: 10px; margin-left: 4px; vertical-align: middle; }
  .deal-price {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px; font-weight: 600;
    color: var(--brass);
  }
  .meta {
    font-size: 11px; color: var(--text-mute);
    display: flex; align-items: center; gap: 8px;
    flex-wrap: wrap;
  }
  .sep { width: 3px; height: 3px; background: var(--text-dim); border-radius: 50%; }
  .reason {
    font-size: 11px; color: var(--danger);
    margin-top: 4px; font-weight: 500;
  }
  .alert.warn .reason { color: var(--warning); }
</style>
